<template>
  <PageHeader title="Account"> </PageHeader>
  <ThePage customWidthClass="tw-max-w-3xl tw-mx-auto tw-justify-center">
    <BlockStack :gap="800" customWidthClass="tw-w-full tw-mx-auto">
      <PageSection>
        <TheCard>
          <CardHeader :showTitle="true" title="Profile"> </CardHeader>
          <TheBox :noTopPadding="true">
            <div class="tw-w-auto">
              <dl
                class="tw-mt-0 tw-space-y-2 tw-divide-solid tw-divide-x-0 tw-divide-y tw-divide-gray-100 tw-border-t tw-border-gray-200 tw-text-sm tw-leading-6"
              >
                <div class="sm:tw-flex">
                  <dt
                    class="tw-font-medium tw-text-gray-900 sm:tw-w-64 sm:tw-flex-none sm:tw-pr-6"
                  >
                    Full name
                  </dt>
                  <dd
                    class="tw-mt-1 tw-flex tw-justify-between tw-gap-x-6 sm:tw-mt-0 sm:tw-flex-auto"
                  >
                    <div class="tw-text-gray-900">
                      {{ userFullName }}
                    </div>
                    <!-- <TheButton variant="primary" size="small">
                      <template #text>Update</template>
                    </TheButton> -->
                  </dd>
                </div>
                <div class="tw-pt-6 sm:tw-flex">
                  <dt
                    class="tw-font-medium tw-text-gray-900 sm:tw-w-64 sm:tw-flex-none sm:tw-pr-6"
                  >
                    Email address
                  </dt>
                  <dd
                    class="tw-mt-1 tw-flex tw-justify-between tw-gap-x-6 sm:tw-mt-0 sm:tw-flex-auto"
                  >
                    <div class="tw-text-gray-900">{{ userEmail }}</div>
                  </dd>
                </div>
              </dl>
            </div>
          </TheBox>
        </TheCard>
      </PageSection>

      <template v-if="this.isBoldXchangeAdmin || this.isGiftingLead">
        <PageSection>
          <StripeDefaultPaymentCard></StripeDefaultPaymentCard>
          <SubscriptionsHistoryList></SubscriptionsHistoryList>
        </PageSection>
      </template>
    </BlockStack>
  </ThePage>
</template>

<script>
import SubscriptionsHistoryList from "../../components-v2/subscriptions/SubscriptionsHistoryList";
import StripeDefaultPaymentCard from "../../components-v2/stripe/payments/StripeDefaultPaymentCard.vue";
import PageHeader from "../../components-v2/ui/layout/PageHeader";
import ThePage from "../../components-v2/ui/layout/ThePage";
import BlockStack from "../../components-v2/ui/layout/BlockStack";
import PageSection from "../../components-v2/ui/layout/PageSection";
import TheBox from "../../components-v2/ui/layout/TheBox";
import TheCard from "../../components-v2/ui/layout/TheCard";
import CardHeader from "../../components-v2/ui/layout/CardHeader";

export default {
  name: "AccountSettings",
  components: {
    SubscriptionsHistoryList,
    StripeDefaultPaymentCard,
    PageHeader,
    ThePage,
    BlockStack,
    PageSection,
    TheBox,
    TheCard,
    CardHeader,
  },
  data() {
    return {
      selectedUser: {},
      clientName: "",
      isLoading: true,
      totalSalesCount: 0,
      totalGiftsDelivered: 0,
      totalVendorsSupported: 0,
      paymentInformation: {},
      subscription: {},
      showModal: false,
      isEditingFullName: false,
      hasDefaultPaymentMethod: false,
    };
  },
  computed: {
    User() {
      return this?.$store?.state?.auth?.user;
    },
    userFullName() {
      return (
        this?.$store?.state?.auth?.user?.firstName +
        " " +
        this?.$store?.state?.auth?.user?.lastName
      );
    },
    userEmail() {
      return this?.$store?.state?.auth?.user?.email;
    },
    userCompany() {
      return this?.$store?.state?.auth?.user?.client?.name;
    },
    /** subscription info */
    subscriptionName() {
      return this?.subscription?.name;
    },

    /** payment info */
    paymentCardBrand() {
      return this?.paymentInformation?.card?.display_brand;
    },
    paymentCardLastFourDigits() {
      return this?.paymentInformation?.card?.last4;
    },
    paymentCardExpirationDate() {
      return (
        this?.paymentInformation?.card?.exp_month +
        " / " +
        this?.paymentInformation?.card?.exp_year
      );
    },
    paymentMethodButtonClass() {
      return this.hasDefaultPaymentMethod ? "primary" : "critical";
    },
  },
  methods: {
    toggleRedemptionsNotifications() {
      this.receiveRedemptionsNotifications =
        !this.receiveRedemptionsNotifications;
    },
    toggleClicksNotifications() {
      this.receiveClicksNotifications = !this.receiveClicksNotifications;
    },

    /** handles setting up payment method */
    async setupPaymentMethod() {
      /**@type {import('@boldxchange/sdk/defs').Client}*/

      const api = await this.getBoldClient();
      const successUrl =
        window.location.origin + "/payment-method/save/{CHECKOUT_SESSION_ID}";
      const cancelUrl = window.location.origin + "/account";

      try {
        const paymentMethodRes = await api.setupPaymentMethod({
          successUrl: successUrl,
          cancelUrl: cancelUrl,
        });
        const paymentUrl = paymentMethodRes.data;
        window.location.href = paymentUrl.url;
      } catch (error) {
        console.log("defaultPaymentRes error: ", error);
      }
    },
  },
};
</script>

<style scoped></style>
